
import { MailboxInterface } from '@/services/Mailbox/interfaces';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';

@Component({
  mixins: [ Themeable ],
})
export default class ToggleMailboxDialog extends Vue {
  @Prop() mailbox!: MailboxInterface;

  @Prop() domain!: string;

  public visible: boolean = true;

  public get message(): string {
    const status = [1, 4].includes(this.mailbox.status) ? 'Disable' : 'Enable';

    return `Are you sure you want to ${status} mailbox for website ${this.domain}?`;
  }

  public toggle(): void {
    this.$emit('toggle', this.mailbox);

    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
